import React, { useState, useEffect } from "react";
import { Grid, Container, Box, Typography } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import { useParams } from "react-router-dom";
import {
  CustomTitle,
  CustomLabel,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import { useTranslation } from "react-i18next";
import api from "../../globals/axios";
import FarmerCard from "../../components/Custom/CustomCardFarmerList";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles(() => ({
  centerContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
}));

const FpoFarmerList = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [fpoFarmerList, setFpoFamerList] = useState([]);
  const [fpoDetails, setFpoDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const { fpoId } = useParams();

  const fetchFpoFarmerList = async () => {
    try {
      const response = await api.get("/fpo/get-fpo-farmer-list/", {
        params: {
          fpo_id: fpoId,
        },
      });
      setLoading(false);
      setFpoFamerList(response.data);
    } catch (error) {
      console.error("Error fetching FPO list:", error);
      setLoading(false);
    }
  };
  const fetchFPODetails = async () => {
    try {
      const response = await api.get("/fpoaggregator/fpo-details/", {
        params: {
          fpo_id: fpoId,
        },
      });
      setLoading(false);
      setFpoDetails(response.data);
    } catch (error) {
      console.error("Error fetching FPO list:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchFPODetails();
    fetchFpoFarmerList();
  }, [fpoId]);

  console.log("fpoId", fpoDetails);

  return (
    <div>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container sx={{ backgroundColor: "#BEBEBE30", height: "100vh" }}>
          {fpoDetails && fpoDetails.fpo_details && (
            <CustomTitle>{t("FPO Profile")}</CustomTitle>
          )}
          {fpoDetails && fpoDetails.fpo_details && (
            <Box sx={{ marginTop: "20px" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CustomLabel> {t("FPO Name")}:</CustomLabel>
                </Grid>
                <Grid item xs={6}>
                  <CustomValue> {fpoDetails.fpo_details.name}</CustomValue>
                </Grid>
                <Grid item xs={6}>
                  <CustomLabel> {t("Total  Farmers")}:</CustomLabel>
                </Grid>
                <Grid item xs={6}>
                  <CustomValue> {fpoDetails.farmer_count}</CustomValue>
                </Grid>
                <Grid item xs={6}>
                  <CustomLabel> {t("FPO Address")}:</CustomLabel>
                </Grid>
                <Grid item xs={6}>
                  <CustomValue> {fpoDetails.fpo_details.address}</CustomValue>
                </Grid>
              </Grid>
            </Box>
          )}

          {fpoFarmerList.length === 0 ? (
            <Box className={classes.centerContent}>
              <Typography variant="body1">
                {t("No Farmers found with this FPO")}
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                marginTop:
                  fpoDetails && fpoDetails.fpo_details ? "30px" : "0px",
              }}
            >
              <CustomLabel>{t("Farmer List :")}</CustomLabel>
              <div style={{ marginTop: "10px" }}> </div>
              {fpoFarmerList.map((farmer) => (
                <FarmerCard key={farmer.id} farmer={farmer} t={t} />
              ))}
            </Box>
          )}
        </Container>
      </LoaderContainer>
    </div>
  );
};

export default FpoFarmerList;
